import React from "react";

const Pay = () => {
  return (
    <div>
      <h2 className="mt-4 text-center">Payment is coming soon!</h2>
    </div>
  );
};

export default Pay;
